
import { AfterViewInit, Directive, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { skip, take, takeUntil } from "rxjs/operators";
import { ScrollPositionService } from "../scroll-position/scroll-position.service";

@Directive({
    selector: "hex-dropdown-menu,[conduitScrollAnchor]",
})
export class ConduitScrollAnchorDirective implements AfterViewInit, OnDestroy {
    public firstX: number;
    public firstY: number;
    public destroyed$ = new Subject();

    constructor(private scrollPositionRef$: ScrollPositionService) { }

    public ngAfterViewInit() {
        this.scrollPositionRef$.pipe(take(1)).subscribe((scrollPositionOffset) => {
            const firstPosition = this.conduitWrapper.getBoundingClientRect();
            this.firstX = firstPosition.x + scrollPositionOffset.x;
            this.firstY = firstPosition.y + scrollPositionOffset.y;
        });

        this.scrollPositionRef$.pipe(skip(1), takeUntil(this.destroyed$)).subscribe((position) => {
            this.onScroll(position);
        });
    }

    public ngOnDestroy() {
        this.destroyed$.next();
    }

    public onScroll(position) {
        this.conduitWrapper.style.left = this.buildStylePosition(this.firstX - position.x);
        this.conduitWrapper.style.top = this.buildStylePosition(this.firstY - position.y);
    }

    public buildStylePosition(value: number): string {
        return `${value}px`;
    }

    public get conduitWrapper(): any {
        return window.document.querySelector("hex-conduit-affixable-wrapper > .o-wrapper");
    }
}
